// ============================================================================
// YearlyGrid — Personal Finance V2 (Blueprint §5.2)
// Grid de visão anual por grupo — extraído de PersonalFinance.jsx.
// ============================================================================

import React from 'react';

const formatNumber = (val) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(val) || 0));

const MONTHS = Array.from({length: 12}, (_, i) => new Date(0, i).toLocaleString('pt-BR', { month: 'short' }));
const DEFAULT_GROUPS = ['RECEITAS', 'ESSENCIAIS', 'PETS', 'ESTILO', 'FUTURO'];

export function YearlyGrid({ yearPostings, templates, yearViewMode, setYearViewMode, onCellClick }) {
    const grid = {};
    DEFAULT_GROUPS.forEach(g => grid[g] = Array(12).fill(0));

    yearPostings.forEach(p => {
        const month = new Date(p.date + 'T12:00:00').getMonth();
        if (grid[p.group]) grid[p.group][month] += Number(p.value);
    });

    if (yearViewMode === 'ALL') {
        const currentMonthIdx = new Date().getMonth();
        templates.forEach(t => {
            if (t.active && grid[t.group]) {
                for (let i = 0; i < 12; i++) {
                    if (i >= currentMonthIdx) {
                        const exists = yearPostings.some(p => p.templateId === t.id && new Date(p.date + 'T12:00:00').getMonth() === i);
                        if (!exists) grid[t.group][i] += Number(t.amount);
                    }
                }
            }
        });
    }

    return (
        <div className="overflow-x-auto bg-white border border-[#d1d5db]">
            <div className="flex justify-end px-3 py-1.5 bg-[#f3f4f6] border-b border-[#d1d5db]">
                <div className="flex items-center bg-white border border-[#d1d5db]">
                    <button onClick={() => setYearViewMode('ALL')} className={`px-3 py-1 text-[10px] font-bold ${yearViewMode === 'ALL' ? 'bg-[#20243B] text-white' : 'text-[#6b7280] hover:bg-[#e5e7eb]'}`}>PREVISTO (Tudo)</button>
                    <button onClick={() => setYearViewMode('PAID_ONLY')} className={`px-3 py-1 text-[10px] font-bold ${yearViewMode === 'PAID_ONLY' ? 'bg-[#059669] text-white' : 'text-[#6b7280] hover:bg-[#e5e7eb]'}`}>REALIZADO (Pago)</button>
                </div>
            </div>
            <table className="w-full text-sm text-right border-collapse">
                <thead className="bg-[#f0f0f0] text-[#374151] font-semibold text-[10px] tracking-wider">
                    <tr>
                        <th className="p-3 text-left border-r border-[#d1d5db] sticky left-0 bg-[#f0f0f0] z-10">Grupo</th>
                        {MONTHS.map(m => <th key={m} className="p-3 border-r border-[#e5e7eb] min-w-[80px]">{m.toUpperCase()}</th>)}
                        <th className="p-3 bg-[#e5e7eb] min-w-[100px]">TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    {DEFAULT_GROUPS.map(g => {
                        const rowTotal = grid[g].reduce((a, b) => a + b, 0);
                        return (
                            <tr key={g} className="hover:bg-[#fafafa] group border-b border-[#e5e7eb]">
                                <td className="p-3 text-left font-bold text-[#374151] border-r border-[#d1d5db] sticky left-0 bg-white group-hover:bg-[#fafafa] text-xs">{g}</td>
                                {grid[g].map((val, idx) => (
                                    <td key={idx} onClick={() => onCellClick(g, idx)} className={`p-3 border-r border-[#e5e7eb] cursor-pointer hover:bg-[#e8f0fe]/40 text-xs ${val > 0 ? (g === 'RECEITAS' ? 'text-[#059669] font-medium' : 'text-[#374151]') : 'text-[#d1d5db]'}`} title="Clique para ver detalhes">
                                        {val > 0 ? formatNumber(val) : '-'}
                                    </td>
                                ))}
                                <td className="p-3 font-bold bg-[#fafafa] border-l border-[#d1d5db] text-xs">{formatNumber(rowTotal)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
